export type PulseErrorEnvelope = {
  error: {
    code: string;
    message: string;
    details?: unknown;
    request_id?: string;
  };
};

export class PulseError extends Error {
  status: number;
  code: string;
  details?: unknown;
  requestId?: string;

  constructor(status: number, code: string, message: string, details?: unknown, requestId?: string) {
    super(message);
    this.name = "PulseError";
    this.status = status;
    this.code = code;
    this.details = details;
    this.requestId = requestId;
  }
}

export async function parseErrorResponse(response: Response): Promise<PulseError> {
  let payload: PulseErrorEnvelope | undefined;
  try {
    payload = (await response.json()) as PulseErrorEnvelope;
  } catch {
    payload = undefined;
  }

  if (payload?.error) {
    return new PulseError(
      response.status,
      payload.error.code,
      payload.error.message,
      payload.error.details,
      payload.error.request_id,
    );
  }

  const fallbackCode = response.status >= 500 ? "internal_error" : "invalid_request";
  return new PulseError(response.status, fallbackCode, "Pulse request failed");
}
